module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg4-704fba3fd259be0234534fa7718624b1.jpg";